export const DEFAULT_SEO_PAGES = {
  "/": {
    slug: "",
    title: "SF Learning — Formations & accompagnements",
    description: "Découvre SF Learning, une plateforme de formations et d'accompagnements pour transformer ton quotidien, ton mindset et ton leadership.",
  },
  "/catalog": {
    slug: "catalog",
    title: "Catalogue des formations — SF Learning",
    description: "Explore les formations et packs SF Learning pour développer ton mindset, ta clarté, ton organisation et ton leadership.",
  },
  "/blog": {
    slug: "blog",
    title: "Blog — SF Learning",
    description: "Conseils, inspirations et ressources SF Learning pour avancer dans ta transformation personnelle et professionnelle.",
  },
  "/affiliate": {
    slug: "affiliate",
    title: "Programme partenaires — SF Learning",
    description: "Recommande les programmes SF Learning et développe une source de revenus grâce au programme partenaires.",
  },
  "/packs": {
    slug: "packs",
    title: "Packs & offres groupées — SF Learning",
    description: "Découvre les packs SF Learning pour accéder à plusieurs formations complémentaires et accélérer ta transformation avec une offre groupée.",
  },
  "/diagnostic-strategique": {
    slug: "diagnostic-strategique",
    title: "Diagnostic stratégique offert — SF Learning",
    description: "Réserve ton diagnostic stratégique offert pour identifier les blocages qui freinent ton recrutement, ton leadership et la croissance de ton entreprise.",
  },
  "/mentions-legales": {
    slug: "mentions-legales",
    title: "Mentions légales — SF Learning",
    description: "Consulte les mentions légales de SF Learning.",
  },
  "/politique-confidentialite": {
    slug: "politique-confidentialite",
    title: "Politique de confidentialité — SF Learning",
    description: "Consulte la politique de confidentialité de SF Learning.",
  },
  "/conditions-generales-de-vente": {
    slug: "conditions-generales-de-vente",
    title: "Conditions générales de vente — SF Learning",
    description: "Consulte les conditions générales de vente de SF Learning.",
  },
};

export const SEO_PAGE_LABELS = {
  "/": "Accueil",
  "/catalog": "Catalogue",
  "/blog": "Blog",
  "/affiliate": "Parrainage",
  "/packs": "Packs / pages détail packs",
  "/diagnostic-strategique": "Diagnostic stratégique offert",
  "/mentions-legales": "Mentions légales",
  "/politique-confidentialite": "Politique de confidentialité",
  "/conditions-generales-de-vente": "Conditions générales de vente",
};

export function normalizeSlug(value = "") {
  return String(value)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9-/\s]/g, "")
    .replace(/[\s_]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^\/+|\/+$/g, "")
    .replace(/\/+/g, "/");
}

export function getSeoPages(settings = {}) {
  return { ...DEFAULT_SEO_PAGES, ...(settings.seo_pages || {}) };
}

export function getSeoPage(settings = {}, originalPath = "/") {
  return getSeoPages(settings)[originalPath] || DEFAULT_SEO_PAGES[originalPath] || {};
}

export function getPublicPath(settings = {}, originalPath = "/") {
  if (originalPath === "/") return "/";
  const page = getSeoPage(settings, originalPath);
  const fallbackSlug = originalPath.replace(/^\//, "");
  const slug = normalizeSlug(page.slug || fallbackSlug);
  return `/${slug || fallbackSlug}`;
}
